import type { SVGProps } from 'react';

const SvgReactionHeartMd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.7903 20.9928 11.5824 20.9787 11.3763'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10 10C10 10.5523 9.55228 11 9 11C8.44772 11 8 10.5523 8 10C8 9.44772 8.44772 9 9 9C9.55228 9 10 9.44772 10 10Z'
      fill='currentColor'
    />
    <path
      d='M16 10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10C14 9.44772 14.4477 9 15 9C15.5523 9 16 9.44772 16 10Z'
      fill='currentColor'
    />
    <path d='M9.0001 10H9' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' />
    <path d='M15.0001 10H15' stroke='currentColor' strokeWidth={1.5} strokeLinecap='round' />
    <path
      d='M16 13.75C16.2598 13.75 16.501 13.8846 16.6377 14.1055C16.7743 14.3267 16.7873 14.6035 16.6709 14.8359C15.6887 16.7973 14.0279 18.25 12 18.25C9.97204 18.25 8.31126 16.7973 7.32908 14.8359C7.21266 14.6034 7.22565 14.3267 7.36228 14.1055C7.49897 13.8846 7.74016 13.75 7.99998 13.75H16Z'
      fill='currentColor'
    />
    <path
      d='M17.2 2C15.985 2 15 3.00431 15 4.24318C15 6.48637 17.6 8.52563 19 9C20.4 8.52563 23 6.48637 23 4.24318C23 3.00431 22.015 2 20.8 2C20.0559 2 19.3981 2.37663 19 2.95311C18.6019 2.37663 17.9441 2 17.2 2Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgReactionHeartMd;
